import type { RoadMapData } from '../types/disclosure'

export const roadMapData: RoadMapData = {
  header: {
    borrowerName: 'Zakary Fellows',
    loanNumber: '1226540085',
    disclosureStatus: 'Requested',
    propertyStreet: '412 Bergen Avenue',
    propertyState: 'NJ',
    loanPurpose: 'Refinance',
    loanOfficer: 'Brent Vaccaro',
    lender: 'UWM',
    madisonECD: '9/16/2026',
    disclosuresRequestedDate: '8/12/2026, 2:40 PM',
    outstandingItems: 2,
    totalItems: 24,
  },

  sections: [
    {
      id: 'required-contacts',
      number: 1,
      title: 'Required Contacts',
      groups: [
        {
          id: 'borrower',
          title: 'Borrower',
          fields: [
            {
              label: 'Borrower First Name',
              value: 'Zakary',
              api: 'imbus__Borrower_First_Name__c',
              object: 'Opportunity',
            },
            {
              label: 'Borrower Middle Name',
              value: null,
              api: 'imbus__Borrower_Middle_Name__c',
              object: 'Opportunity',
            },
            {
              label: 'Borrower Last Name',
              value: 'Fellows',
              api: 'imbus__Borrower_Last_Name__c',
              object: 'Opportunity',
            },
            {
              label: 'Borrower Email',
              value: 'zakary.fellows@gmail.com',
              api: 'imbus__Borrower_Email__c',
              object: 'Opportunity',
            },
            {
              label: 'Borrower Mobile',
              value: '(201) 555-0184',
              api: 'imbus__Borrower_Mobile__c',
              object: 'Opportunity',
            },
            {
              label: 'Preferred Contact Language',
              value: 'English',
              api: 'Preferred_Contact_Language__c',
              object: 'Opportunity',
            },
            {
              label: 'Preferred Contact Method',
              value: 'Email',
              api: 'imbus__Preferred_Contact_Method__c',
              object: 'Opportunity',
            },
          ],
        },
        {
          id: 'referral',
          title: 'Referral Information',
          fields: [
            {
              label: 'Is this a Referral Loan?',
              value: 'No',
              api: 'Is_Referral_Loan__c',
              object: 'Opportunity',
              type: 'yesno',
            },
            {
              label: 'Referring Loan Officer',
              value: null,
              api: 'Referring_Loan_Officer__c',
              object: 'User',
              note: 'Required when Referral Loan = Yes',
            },
          ],
        },
        {
          id: 'file-contacts',
          title: 'File Contacts',
          fields: [
            { label: 'Referred By', value: 'Marisol Vega', api: 'imbus__Referred_By__c', object: 'Contact' },
            {
              label: 'Title Company Name',
              value: 'Keystone Title Services',
              api: 'TitleCompanyName__c',
              object: 'Contact',
            },
            { label: 'Settlement Agent', value: 'Dana Whitfield', api: 'Settlement_Agent__c', object: 'Contact' },
            { label: 'HOI Provider', value: 'Garden State Mutual', api: 'HOI_Provider__c', object: 'Contact' },
            {
              label: 'Appraisal Company Name',
              value: 'Not Required — DU Waiver',
              api: 'Appraisal_Company_Name__c',
              object: 'Opportunity',
            },
          ],
        },
        {
          id: 'agents',
          title: 'Real Estate Agents',
          condition: 'Purchase only',
          applicable: false,
          applicabilityNote: 'Loan Purpose is Refinance.',
          fields: [
            { label: "Buyer's Agent", value: null, api: 'imbus__Buyers_Agent__c', object: 'Contact' },
            { label: 'Listing Agent', value: null, api: 'imbus__Listing_Agent__c', object: 'Contact' },
          ],
        },
        {
          id: 'attorneys',
          title: 'Attorneys',
          condition: 'Purchase + NY / CT / TX',
          applicable: false,
          applicabilityNote: 'This is a NJ Refinance.',
          fields: [
            { label: "Buyer's Attorney", value: null, api: 'Buyer_s_Attorney__c', object: 'Contact' },
            { label: "Seller's Attorney", value: null, api: 'Seller_s_Attorney__c', object: 'Contact' },
          ],
        },
        {
          id: 'hoa',
          title: 'HOA',
          condition: 'Condo / Co-op property types only',
          applicable: false,
          applicabilityNote: 'Property Type is Single Family.',
          fields: [
            { label: 'Condo/Co-op HOA Contact', value: null, api: 'Condo_Co_op_HOA_Contact__c', object: 'Contact' },
          ],
        },
      ],
    },

    {
      id: 'property-transaction',
      number: 2,
      title: 'Property & Transaction',
      groups: [
        {
          id: 'property',
          fields: [
            {
              label: 'Property Street',
              value: '412 Bergen Avenue',
              api: 'imbus__Property_Street__c',
              object: 'Opportunity',
            },
            { label: 'Property State', value: 'NJ', api: 'imbus__Property_State__c', object: 'Opportunity' },
            { label: 'Property Type', value: 'Single Family', api: 'imbus__Property_Type__c', object: 'Opportunity' },
            { label: 'Loan Purpose', value: 'Refinance', api: 'imbus__Transaction_Type__c', object: 'Opportunity' },
            {
              label: 'Madison ECD (Estimated Closing Date)',
              value: '9/16/2026',
              api: 'EstimatedClosingDate__c',
              object: 'Opportunity',
              type: 'date',
            },
            {
              label: 'I certify that this Madison ECD is correct.',
              value: 'Certified',
              api: 'madisonECDCertified',
              object: 'UI only',
              type: 'certified',
            },
          ],
        },
      ],
    },

    {
      id: 'loan-product',
      number: 3,
      title: 'Loan Product',
      groups: [
        {
          id: 'product',
          fields: [
            {
              label: 'Is this a QM or Non-QM Loan Product?',
              value: 'QM',
              api: 'QMorNonQM__c',
              object: 'Opportunity',
            },
            {
              label: 'Non-QM Product Type',
              value: null,
              api: 'DiscReqLoanProduct__c',
              object: 'Opportunity',
              note: 'Shown when QM Type = Non-QM',
            },
            {
              label: 'DSCR Ratio',
              value: null,
              api: 'DSCR_Ratio__c',
              object: 'Opportunity',
              note: 'Shown when Non-QM product contains DSCR',
            },
            {
              label: 'Processing Type',
              value: 'Full-Service Processing',
              api: 'ProcessingType__c',
              object: 'Opportunity',
            },
            {
              label: 'AUS Findings Certified',
              value: 'Certified',
              api: 'ausFindingsCertified',
              object: 'UI only',
              type: 'certified',
            },
          ],
        },
      ],
    },

    {
      id: 'disclosure-details',
      number: 4,
      title: 'Disclosure Details',
      groups: [
        {
          id: 'always-visible',
          title: 'Always Visible',
          fields: [
            { label: 'Channel', value: 'Wholesale', api: 'Channel__c', object: 'Opportunity' },
            { label: 'Designated Lender', value: 'UWM', api: 'imbus__Chosen_Lender__c', object: 'Opportunity' },
            { label: 'Lock Period', value: '30 Days', api: 'Lock_Period__c', object: 'Checklist__c' },
            { label: 'Closing Type', value: 'In-Person', api: 'ClosingType__c', object: 'Opportunity' },
            { label: 'Loan Source', value: 'Repeat Client', api: 'Loan_Source__c', object: 'Opportunity' },
            { label: 'Review LE & Pricing', value: 'Yes', api: 'ReviewLEAndPricing__c', object: 'Opportunity' },
            {
              label: 'Appraisal Order Status',
              value: 'Not Ordered',
              api: 'Appraisal_Order_Status__c',
              object: 'Opportunity',
              note: 'Display only — not round-tripped on save yet',
            },
            {
              label: 'Title Order Status',
              value: 'Ordered',
              api: 'Title_Order_Status__c',
              object: 'Opportunity',
              note: 'Display only — not round-tripped on save yet',
            },
            { label: 'Is a New Deed Required?', value: 'No', api: 'New_Deed__c', object: 'Checklist__c', type: 'yesno' },
            {
              label: 'Lock At Disclosure',
              value: 'No',
              api: 'Lock_at_Disclosure__c',
              object: 'Opportunity',
              type: 'yesno',
            },
            {
              label: 'Will this Loan receive compensation on both front and back via YSP?',
              value: 'No',
              api: 'Loan_Received_Compensation_via_YSP__c',
              object: 'Opportunity',
              type: 'yesno',
            },
            {
              label: 'Waive Underwriting Fee?',
              value: 'No',
              api: 'Waive_Underwriting_Fee__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'New Construction?',
              value: 'No',
              api: 'New_Construction__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Prepayment Penalty Term',
              value: 'No Prepayment Penalty',
              api: 'Pre_Payment_penalty_duration__c',
              object: 'Checklist__c',
            },
            {
              label: 'Is there a pre-payment penalty?',
              value: 'No',
              api: 'Is_Prepayment_Penalty__c',
              object: 'Checklist__c',
              type: 'yesno',
              note: 'Derived from the prepayment term',
            },
            {
              label: 'Paystubs in 60 days of Disclosure Date?',
              value: 'Yes',
              api: 'Paystubs_in_60_days_of_Disclosure_Date__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Are you utilizing future income?',
              value: 'No',
              api: 'Are_you_utilizing_future_income__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Clearly Validated Offer Letter?',
              value: 'No',
              api: 'Is_Clearly_Validated_Offer_Letter__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Are any borrowers employed by family?',
              value: 'No',
              api: 'Are_any_borrowers_employed_by_family__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Do we have 2 Years Tax Returns?',
              value: 'No',
              api: 'Do_we_have_2_Years_Tax_Returns__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            {
              label: 'Appraisal Waiver?',
              value: 'No',
              api: 'Appraisal_Waiver_Requested__c',
              object: 'Checklist__c',
              type: 'yesno',
            },
            { label: 'Escrow Account', value: 'None Waived', api: 'imbus__Escrow_Account__c', object: 'Opportunity' },
            {
              label: 'Borrower Approved Cash at Closing',
              value: '$0.00',
              api: 'Borrower_Approved_Cash_at_Closing__c',
              object: 'Opportunity',
              type: 'currency',
            },
            {
              label: 'Boarded With Lender',
              value: 'No',
              api: 'BoardedWithLender__c',
              object: 'Opportunity',
              type: 'yesno',
            },
            {
              label: 'Confirm Lender Loan Number',
              value: '1226540085',
              api: 'imbus__Loan_Number__c',
              object: 'Opportunity',
            },
          ],
        },
        {
          id: 'authority-trailing-docs',
          title: 'Authority & Trailing Docs',
          description: 'Added 8/28 for the DocProbe trailing-doc export.',
          fields: [
            { label: 'Power of Attorney (POA)', value: 'No', api: 'POA__c', object: 'Opportunity', type: 'yesno' },
            {
              label: 'CEMA',
              value: null,
              api: 'CEMA__c',
              object: 'Opportunity',
              note: 'New York subject properties only',
            },
            { label: 'Pool #', value: null, api: 'Pool_Number__c', object: 'Opportunity' },
            { label: 'Custodian', value: null, api: 'Custodian__c', object: 'Opportunity' },
            {
              label: 'Servicer / Sub-servicer',
              value: null,
              api: 'Servicer_Name__c',
              object: 'Opportunity',
              note: 'Added manually post-export',
            },
          ],
        },
        {
          id: 'conditional-lock-period',
          title: 'Conditional — Lock Period',
          condition: 'Lock Period = Custom',
          applicable: false,
          applicabilityNote: 'Lock Period is 30 Days.',
          fields: [{ label: 'Custom Lock Period', value: null, api: 'Custom_Lock_Period__c', object: 'Checklist__c' }],
        },
        {
          id: 'conditional-correspondent',
          title: 'Conditional — Channel = Correspondent',
          condition: 'Channel = Correspondent',
          applicable: false,
          applicabilityNote: 'Channel is Wholesale.',
          fields: [
            { label: 'Origination Fee %', value: null, api: 'Origination_Fee__c', object: 'Checklist__c' },
            {
              label: 'Discount Fee %',
              value: null,
              api: 'discountFeePercent',
              object: 'Checklist__c',
              note: 'Not mapped to save yet',
            },
          ],
        },
        {
          id: 'conditional-non-correspondent',
          title: 'Conditional — Channel ≠ Correspondent',
          condition: 'Applies — Channel is Wholesale',
          fields: [
            {
              label: 'Originator Comp Type',
              value: 'Borrower Paid',
              api: 'Origination_Comp_Type__c',
              object: 'Checklist__c',
              note: 'No default is applied on correspondent loans',
            },
            {
              label: 'Origination Fee %',
              value: '2.25%',
              api: 'Origination_Fee__c',
              object: 'Checklist__c',
              note: 'Shown when Comp Type = Borrower Paid',
            },
          ],
        },
        {
          id: 'conditional-purchase',
          title: 'Conditional — Purchase only',
          condition: 'Loan Purpose = Purchase',
          applicable: false,
          applicabilityNote: 'Loan Purpose is Refinance.',
          fields: [
            {
              label: 'Mortgage Commitment Due',
              value: null,
              api: 'imbus__Mortgage_Commitment_Due__c',
              object: 'Opportunity',
            },
            {
              label: 'Is Buyer Paying Seller Transfer Tax?',
              value: null,
              api: 'Is_Seller_Transfer_Tax__c',
              object: 'Checklist__c',
            },
            {
              label: 'Is Buyer Paying Realtor Commission?',
              value: null,
              api: 'Is_Buyer_Paying_Realtor_Commission__c',
              object: 'Checklist__c',
            },
          ],
        },
        {
          id: 'conditional-purchase-yes',
          title: 'Conditional — Purchase + Yes answers',
          condition: 'Purchase + buyer paying transfer tax / realtor commission',
          applicable: false,
          applicabilityNote: 'Loan Purpose is Refinance.',
          fields: [
            { label: 'Transfer Tax Amount', value: null, api: 'Transfer_Tax_Amount__c', object: 'Checklist__c' },
            { label: 'Realtor Commission', value: null, api: 'Realtor_Commission__c', object: 'Checklist__c' },
          ],
        },
      ],
    },
  ],

  notesSection: {
    id: 'notes',
    number: 5,
    title: 'Notes',
    notes: [
      {
        id: 'roadmapNotes',
        label: 'Roadmap',
        api: 'Opportunity.Road_Map__c',
        value:
          'UWM Elite Conv 30 year fixed\n6.625% 2.25 BPC\n\nRate and term refinance, fiancé coming off title — no buyout\nProceeding DU which allows non-occupying co-borrower\nWill request CYP at disclosure',
      },
      {
        id: 'appraisalNotes',
        label: 'Appraisal Notes',
        api: 'Opportunity.Appraisal_Notes__c',
        value: 'Est Value: $600K\nDU no appraisal needed',
      },
      {
        id: 'incomeNotes',
        label: 'Income Notes',
        api: 'Opportunity.Income_Notes__c',
        value: 'Using B2 salary',
      },
      {
        id: 'assetNotes',
        label: 'Asset Notes',
        api: 'Opportunity.Asset_Notes__c',
        value: null,
      },
      {
        id: 'creditNotes',
        label: 'Credit Notes',
        api: 'Opportunity.Credit_Notes__c',
        value: 'Using Vantage 736 (756-20)\nDTI: 30.96/36.57',
      },
    ],
  },
}
